import { call, put, select, takeEvery, takeLatest } from 'typed-redux-saga'
import {
	RbidosRequest,
	orderListApi,
	OrdersListNS,
	ordersListSlice,
	ordersListSelectors,
} from 'Pages/registratorCabinet'
import {
	errorHandler,
	notifyMessageCreator,
	NOTIFICATION_TYPE,
	loadersSlice,
	gridSlice,
} from 'Modules'
import { RequestParams, ResponseCatalog } from 'Models'
import { authSelector, authSlice } from 'Pages/auth'

function* getList(action: OrdersListNS.GetRbidosRequestList) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(ordersListSlice.actions.clearAll())
		}
		const res = yield* call(orderListApi.getAll, requestParams)
		const rbidosRequests = new ResponseCatalog<RbidosRequest>(res)
		if (!clear) {
			const oldRbidosRequests = yield* select(ordersListSelectors.getAll)
			rbidosRequests.entries = oldRbidosRequests.concat(res.entries)
		}
		yield* put(ordersListSlice.actions.setAll(rbidosRequests))
		yield* put(ordersListSlice.actions.setRequestParams(requestParams))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

export function* infotecsLogin(action: OrdersListNS.InfotecsLogin) {
	try {
		const { data } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(orderListApi.infotecsLogin, data)
		const { id } = yield* select(authSelector.getAuthDataSelector)
		yield* call(notifyMessageCreator, 'rbidos.infotex_login.success')
		yield* put(authSlice.actions.getUser({ id }))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* deleteInfotecsLogin() {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(orderListApi.deleteInfotecsLogin)
		const { id } = yield* select(authSelector.getAuthDataSelector)
		yield* put(authSlice.actions.getUser({ id }))
		yield* call(notifyMessageCreator, 'rbidos.infotex_logout.success')
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		const errors = error?.data?.errors ?? []
		yield* call(notifyMessageCreator, 'rbidos.infotex_logout.error', {
			data: errors,
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
	}
}

export function* ordersListSaga() {
	yield* takeLatest(ordersListSlice.actions.getAll.type, getList)
	yield* takeEvery(ordersListSlice.actions.infotecsLogin.type, infotecsLogin)
	yield* takeEvery(ordersListSlice.actions.deleteInfotecsLogin.type, deleteInfotecsLogin)
}
